import { createSlice } from '@reduxjs/toolkit';

import {
  getUserInfo,
  logoutUser,
  setCurrentUser,
  getSchoolById,
} from './actions';

const initialState = {
  user: null as any,
  school: null as any,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(setCurrentUser, (state: any, action: any) => {
      state.user = action.payload;

      if (action.payload) {
        state.isAuthenticated = true;
      } else {
        state.isAuthenticated = false;
      }
    });

    builder.addCase(getUserInfo.fulfilled, (state: any, action: any) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    });

    builder.addCase(logoutUser, () => {
      return initialState;
    });

    builder.addCase(getSchoolById.fulfilled, (state: any, action: any) => {
      state.school = action.payload;
    });
  },
});

export default authSlice.reducer;
